<template>
  <v-tabs
    v-model="selectedTab"
    height="34"
    fixed-tabs
    background-color="white"
    hide-slider
    class="toggle-tabs"
    :show-arrows="false"
    centered
  >
    <v-tooltip :open-delay="500" bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-tab
          role="tab"
          v-bind="attrs"
          v-on="on"
          @click="showMapOnly"
          @keyup.space="showMapOnly"
        >
          <v-icon>mdi-map-outline</v-icon
          >{{ $vuetify.breakpoint.mdAndDown ? "" : "Kart" }}
        </v-tab>
      </template>
      <span>Vis tidsserier i kart</span>
    </v-tooltip>

    <v-divider vertical />

    <v-tooltip :open-delay="500" bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-tab
          v-bind="attrs"
          role="navigation"
          v-on="on"
          @click="showTableOnly"
          @keyup.space="showTableOnly"
        >
          <v-icon>mdi-table</v-icon
          >{{ $vuetify.breakpoint.mdAndDown ? "" : "Tabell" }}
        </v-tab>
      </template>
      <span>Vis tidsserier i tabell</span>
    </v-tooltip>

    <v-divider vertical />

    <v-tooltip :open-delay="500" bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-tab
          v-bind="attrs"
          role="navigation"
          v-on="on"
          @click="showSplitViewHorizontal"
          @keyup.space="showSplitViewHorizontal"
        >
          <v-icon>mdi-view-split-horizontal</v-icon
          >{{ $vuetify.breakpoint.mdAndDown ? "" : "Splitt" }}
        </v-tab>
      </template>
      <span>Vis kart og tabell samtidig</span>
    </v-tooltip>
  </v-tabs>
</template>
<script>
export default {
  name: "TheViewToggler",
  data() {
    return {
      toggle_exclusive: 0,
      selectedTab: 0,
    };
  },
  methods: {
    showMapOnly() {
      this.selectedTab = 0;
      this.$eventHub.$emit("show-map-only");
      this.focusMap();
    },
    showTableOnly() {
      this.selectedTab = 1;
      this.$eventHub.$emit("show-table-only");
      this.focusTable();
    },
    showSplitViewHorizontal() {
      this.selectedTab = 2;
      this.$eventHub.$emit("show-split-view-horizontal");
      this.focusMap();
    },
    focusMap() {
      this.$nextTick(() =>
        document.getElementById("map").children[0].children[0].focus()
      );
    },
    focusTable() {
      this.$nextTick(() => document.getElementById("tableHeading").focus());
    },
  },
};
</script>
<style>
.toggle-tabs {
  min-width: 330px;
  max-width: 330px;
  max-height: 36px;
  border-radius: 6px;
  border-width: 1px;
  border-style: solid;
  border-color: rgba(158, 158, 158, 0.36) !important;
}
</style>
